export const DEALERLESS_OEM = ['tesla', 'rivian', 'lucid', 'fisker'];
export const DEALERLESS_OEM_TRIAL = ['polestar', 'vinfast'];
